import { StringHandler } from "src/app/helpers/StringHandler";
import { eAddressType } from "../../../models/eAddressType";

export class AddressFormFields {
	type? : eAddressType;

	/**
	 * Localidad
	 */
	state : string;

	/**
	 * Conformado por postal_code + postal_code_suffix, + ingresado por el usuario si Google Maps no lo trae
	 */
	zip_code : string;

	/**
	 * formated_address en el objeto que devuelve Google Maps
	 */
	address : string;
	address_floor : string | null;
	address_apartment : string | null;
	extra_notes : string | null;

	latitude : number;
	longitude : number;

	/**
	 * Objeto entero de Google Places que se guarda en la api para futuras features
	 */
	metadata : string;

	constructor(type:eAddressType|null, state:string, zipCode:string, formated_address:string,
				address_floor:string|undefined, address_apartment:string|undefined,
				extraNotes:string|undefined, latitude:number, longitude:number, googlePlaceResult:google.maps.places.PlaceResult|string) {
		if (type)
			this.type = type;

		this.state = state;
		this.zip_code = StringHandler.cleanAllCaps(zipCode);
		this.address = formated_address;
		this.address_floor = StringHandler.cleanSentence(address_floor);
		this.address_apartment = StringHandler.cleanSentence(address_apartment);
		this.extra_notes = StringHandler.cleanSentence(extraNotes);
		this.latitude = latitude;
		this.longitude = longitude;
		
		if (typeof(googlePlaceResult) == "string") {
			this.metadata = googlePlaceResult;
		} else {
			// Esto imprime un error al convertir a json porque la variable está deprecada,
			//	a pesar de que ni siquiera forma parte del objeto a convertir a json
			// Es un error reportado hace 3 años y nunca corregido
			if (googlePlaceResult.utc_offset)
				delete googlePlaceResult.utc_offset;
			this.metadata = JSON.stringify(googlePlaceResult);
		}
	}

	clone(newType:eAddressType) {
		return new AddressFormFields(newType, this.state, this.zip_code, this.address, this.address_floor!, this.address_apartment!, this.extra_notes!, this.latitude, this.longitude, this.metadata);
	}
}